<template>
  <div class="header__container header__container--no-navigation">
    <div class="nav__logo">
      <div v-if="isNeededConfirmModal">
        <div class="unlink-logo" @click="onClickUnlinkLogo('/')">
          <ImgLazy
            :image-url="noNavigationLogoImage"
            alt-text="no-navigation-logo"
            aspect-ratio="80 / 24"
            :width="80"
            :height="24"
          />
        </div>
        <div class="modal header-logo-modal">
          <TextModal
            v-if="isModalActive"
            :title-text="modalText.title"
            :caption-text="modalText.caption"
            :primary-button-text="modalText.primaryButton"
            :cancel-button-text="modalText.cancelButton"
            @clicked-modal-cover="closeModal"
            @clicked-primary="onClickPrimaryButton('/')"
            @clicked-cancel="closeModal"
          />
        </div>
      </div>
      <a v-else href="/">
        <ImgLazy
          :image-url="noNavigationLogoImage"
          alt-text="no-navigation-logo"
          aspect-ratio="80 / 24"
          :width="80"
          :height="24"
        />
      </a>
    </div>
  </div>
</template>
<script>
import TextModal from '../../molecules/modals/text-modal.vue'
import ImgLazy from '../../atoms/images/ImgLazy.vue'
export default {
  components: { TextModal, ImgLazy },
  props: {
    isNeededConfirmModal: {
      type: Boolean,
      required: true
    },
    noNavigationLogoImage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isModalActive: false,
      modalText: {
        title: '確認',
        caption:
          'ギフトコードが適用されていませんがこのまま離れてよろしいですか？適用する場合はキャンセルして「適用する」ボタンを押してください。',
        primaryButton: 'このまま離れる',
        cancelButton: 'キャンセル'
      }
    }
  },
  methods: {
    showModal() {
      this.isModalActive = true
    },
    closeModal() {
      this.isModalActive = false
    },
    onClickUnlinkLogo(url) {
      const giftCodeForm = document.querySelector(
        '#gift_code_serial_form_gift_code'
      )
      if (giftCodeForm && giftCodeForm.value) {
        this.showModal()
        return
      }
      this.moveToUrl(url)
    },
    onClickPrimaryButton(url) {
      this.moveToUrl(url)
    },
    moveToUrl(url) {
      location.href = url
      this.closeModal()
    }
  }
}
</script>
